class ConflictDetailsComponentController {
    constructor(constants) {
        this.conflictCategory = null;
        this.appendix2Link = constants.Links.Appendix2;

        //TODO: move this to some kind of constant.
        this.acknowledgements = [
            {
                id: "trueAndCorrectOk",
                text: "I declare that to best of my knowledge, the information in this form is true and correct."
            },
            {
                id: "informROInFutureOk",
                text: "After the Responsible Officer actions this disclosure, I undertake to inform the Officer in the future (or in their absence, the ISU) of <em class='underline-text'>any changes</em> that may:",
                subtext:    "<ul class='acknowledgement-subtext'>"
                                + "<li>alter that officer’s original decision - in the case where the officer decided I had no conflict of interest or foreign relationship or interest that needed to be addressed; or</li>"
                                + "<li>impact on the need for or effectiveness of the management strategy originally specified - in the case where the officer decided I had a conflict of interest or foreign relationship or interest that needed to be addressed.</li>"
                            + "</ul>"
            },
            {
                id: "notifyIsuInFutureOk",
                text: "I undertake to notify the ISU should at any time in the future, my previously disclosed conflict of interest or foreign relationship or interest no longer exists."
            }
        ];

        this.categoryCallbackUpdateParentIfExists();
    }

    onCategoryUpdated(selectedConflictCategory) {
        this.conflictCategory = selectedConflictCategory;

        this.categoryCallbackUpdateParentIfExists();
    }

    categoryCallbackUpdateParentIfExists() {
        if (this.onCategoryUpdateParent != null) {
            this.onCategoryUpdateParent();
        }
    }

    onFileUploaded(disclosureFile) {
        this.onFileUpload({disclosureFile: disclosureFile});
    } 

    onFileFetched(fileDto) {
        this.onFileFetch({ fileDto: fileDto});
    }

    onFileDeleted(fileDto) {
        this.onFileDelete({ fileDto: fileDto });
    }
}

ConflictDetailsComponentController.$inject = ['constants'];

export default  {
    bindings: {
        conflictCategories: '<',
        employmentOptions: '<',
        conflictStatus: '<',
        readonly: '<',
        discloserFiles: '<',
        onUserValidate: '&',
        onFileUpload: '&',
        onFileFetch: '&',
        onFileDelete: '&',
        onCategoryUpdateParent: '&'
    },
    templateUrl: 'app/disclose/conflictOfInterest/components/conflict-details/conflict-details.html',
    controller: ConflictDetailsComponentController
};


// WEBPACK FOOTER //
// ./app/disclose/conflictOfInterest/components/conflict-details/conflict-details.component.js